module.exports = __webpack_public_path__ + "img/skip-start-fill.54af5780.svg";